import { reactive, resolveComponent } from "vue";
import { createToast } from "../../../modules/toast-message.js";
import { wordPressRequest } from "../../../modules/wordpress.js";
import { empty } from "../helpers.js";

export const basket = reactive({
	data: {},
	items: [],
	urls: {},
	isLoading: false,

	getBasket(basket_uuid = null) {
		this.isLoading = true;

		let data = {
			action      : "acc_get_basket_items",
			url         : window.location.href,
			nonce       : phpVals.btNonce,
		};

		if(basket_uuid){
			data.basket_uuid = basket_uuid
		}

		const params = new URLSearchParams(data);

		wordPressRequest("POST", phpVals.adminAjax, params)
			.then((res) => {
				if (res?.api_response) {
					this.data = res;
					this.items = res.data;
					this.urls = res.urls;
				}
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				this.isLoading = false;
			});
	},

	async addItem(item) {
		const price = JSON.stringify(item.price);

		const url = phpVals.adminAjax;
		let data = new FormData();
		data.append("action", "acc_add_item");
		data.append("nonce", phpVals.btNonce);
		data.append("product", item.id);
		data.append("price", price);
		const params = new URLSearchParams(data);

		try {
			const data_1 = await wordPressRequest("POST", url, params);
			if (data_1?.added?.data?.basket_id) {
				// Show confirmation message
				createToast(data_1.message, "success", phpVals.basketUrl);

				if (this.items.some((item_1) => item_1.id === data_1.added.data.id)) {
					this.items = this.items.filter((item_2) => item_2.id !== data_1.added.data.id);

					this.items.push(data_1.added.data);
				} else {
					this.items.push(data_1.added.data);
				}
			} else {
				createToast("Product could not be added to the basket.", "error");
			}
		} catch (error) {
			console.error(error);

			createToast("Product could not be added to basket.", "error");
		}
	},

	removeItem(el) {
		const basketRowId = el.id;
		const basketRowQuantity = el.quantity;
		const url = phpVals.adminAjax;
		let data = new FormData();

		this.isLoading = true;

		data.append("action", "acc_remove_items");
		data.append("nonce", phpVals.btNonce);
		data.append("basket_row_id", basketRowId);
		data.append("basket_row_quantity", basketRowQuantity);
		const params = new URLSearchParams(data);

		wordPressRequest("POST", url, params)
			.then((data) => {
				console.log(data);

				if (data?.removed) {
					createToast(data.removed[0].message, "success");

					this.items = this.items.filter((item) => item.id !== basketRowId);
				} else {
					createToast("Products could not be removed from basket.", "error");

					this.getBasket();
				}
			})
			.catch((error) => {
				console.error(error);

				this.getBasket();

				createToast("Could not update basket.", "error");
			})
			.finally(() => {
				this.isLoading = false;
			});
	},

	updateItem(item, quantity) {
		item.quantity = parseInt(quantity);

		this.isLoading = true;

		if (item.quantity === 0 || item.quantity < 0) {
			this.removeItem(item);

			return;
		}

		const url = phpVals.adminAjax;
		let data = new FormData();

		data.append("action", "acc_update_items");
		data.append("nonce", phpVals.btNonce);
		data.append("basket_row_id", item.id);
		data.append("basket_row_quantity", item.quantity);
		const params = new URLSearchParams(data);

		wordPressRequest("POST", url, params)
			.then((data) => {
				if (data?.updated && data?.updated?.api_response === "success") {
					// Show confirmation message
					createToast(data.updated.message, "success");
				} else {
					createToast("Product quantity could not be updated.", "error");

					this.getBasket();
				}
			})
			.catch((error) => {
				console.error(error);

				this.getBasket();

				createToast("Product quantity could not be updated.", "error");
			})
			.finally(() => {
				this.getBasket();

				this.isLoading = false;
			});
	},

	totalCost() {
		return this.displayCost(
			this.items.length > 0 ? this.items.reduce((accumulator, item) => accumulator + this.calculateCost(item.price, item.quantity), 0) : 0
		);
	},

	totalItems() {
		return this.items.length > 0 ? this.items.reduce((accumulator, item) => accumulator + item.quantity, 0) : 0;
	},

	getItems() {
		return this.items;
	},

	calculateCost(cost, quantity) {
		return parseFloat(cost) * parseInt(quantity);
	},

	displayCost(cost) {
		if (!cost || cost === 0) return "Free";

		return "&pound;" + parseFloat(cost).toFixed(2);
	},

	requiresLogin() {
		return this.items.some((product) => product.product.requires_login);
	},

	isLoggedIn() {
		return phpVals.acc.isUserLoggedIn;
	},
});
